import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export const ProtectedRoute = ({ children, adminOnly = false }) => {
  const { user, loading } = useAuth();

  if (loading)
    return (
      <div className="min-h-screen flex items-center justify-center">
        <p className="font-display text-2xl text-[#B76E79]">Chargement…</p>
      </div>
    );
  if (!user) return <Navigate to="/connexion" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/ressources" replace />;
  return children;
};
